import type Context from '@absmartly/javascript-sdk/types/context';
import type { EventLoggerData, EventName } from '@absmartly/javascript-sdk/types/sdk';

export function defaultEventLogger(_: Context, eventName: EventName, data?: EventLoggerData): void {
  if (eventName !== 'error') {
    return;
  }

  console.error(data);
}
